<template>
  <b-modal
    size="lg"
    title="Editar recursos"
    id="modal-editar-multi-recursos"
    class="cme-modal"
    ref="modalEditarMultiRecursos"
    no-close-on-backdrop
    hide-header-close
    @shown="recursosSelected"
  >
    <div class="d-block text-center">
      <b-row
        style="margin-top: 5px; margin-bottom: 5px;"
        v-for="(f, index) in dataSelected"
        :key="f._id"
      >
        <b-col cols="3">
          <div class="recurso-obj-content">
            <img
              v-if="f.type == 'IMAGEN'"
              class="recurso-img-content"
              :src="$root.setUrlFile(f.file)"
            />
            <div v-if="f.type == 'VIDEO'" class="uppy-DashboardItem-preview">
              <div
                class="uppy-DashboardItem-previewInnerWrap"
                style="background-color: rgb(25, 175, 103);"
              >
                <div class="uppy-DashboardItem-previewIconWrap">
                  <span class="uppy-DashboardItem-previewIcon" style="color: rgb(25, 175, 103);">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      class="UppyIcon"
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                    >
                      <path
                        d="M16 11.834l4.486-2.691A1 1 0 0 1 22 10v6a1 1 0 0 1-1.514.857L16 14.167V17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2.834zM15 9H5v8h10V9zm1 4l5 3v-6l-5 3z"
                        fill="#19AF67"
                        fill-rule="nonzero"
                      />
                    </svg>
                  </span>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    class="uppy-DashboardItem-previewIconBg"
                    width="58"
                    height="76"
                    viewBox="0 0 58 76"
                  >
                    <rect fill="#FFF" width="58" height="76" rx="3" fill-rule="evenodd" />
                  </svg>
                </div>
              </div>
              <div class="uppy-DashboardItem-progress">
                <button
                  class="uppy-u-reset uppy-DashboardItem-progressIndicator"
                  type="button"
                  aria-label="Pausar subida"
                  title="Pausar subida"
                >
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    width="70"
                    height="70"
                    viewBox="0 0 36 36"
                    class="UppyIcon UppyIcon-progressCircle"
                  >
                    <g class="progress-group">
                      <circle class="bg" r="15" cx="18" cy="18" stroke-width="2" fill="none" />
                      <circle
                        class="progress"
                        r="15"
                        cx="18"
                        cy="18"
                        transform="rotate(-90, 18, 18)"
                        stroke-width="2"
                        fill="none"
                        stroke-dasharray="94.24777960769379"
                        stroke-dashoffset="94.24777960769379"
                      />
                    </g>
                    <g>
                      <polygon class="play" transform="translate(3, 3)" points="12 20 12 10 20 15" />
                      <g class="pause" transform="translate(14.5, 13)">
                        <rect x="0" y="0" width="2" height="10" rx="0" />
                        <rect x="5" y="0" width="2" height="10" rx="0" />
                      </g>
                      <polygon
                        class="cancel"
                        transform="translate(2, 2)"
                        points="19.8856516 11.0625 16 14.9481516 12.1019737 11.0625 11.0625 12.1143484 14.9481516 16 11.0625 19.8980263 12.1019737 20.9375 16 17.0518484 19.8856516 20.9375 20.9375 19.8980263 17.0518484 16 20.9375 12"
                      />
                    </g>
                    <polygon
                      class="check"
                      transform="translate(2, 3)"
                      points="14 22.5 7 15.2457065 8.99985857 13.1732815 14 18.3547104 22.9729883 9 25 11.1005634"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div v-if="f.type == 'AUDIO'" class="uppy-DashboardItem-preview">
              <div
                class="uppy-DashboardItem-previewInnerWrap"
                style="background-color: rgb(6, 141, 187);"
              >
                <div class="uppy-DashboardItem-previewIconWrap">
                  <span class="uppy-DashboardItem-previewIcon" style="color: rgb(6, 141, 187);">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      class="UppyIcon"
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                    >
                      <path
                        d="M9.5 18.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V7.25a.5.5 0 0 1 .379-.485l9-2.25A.5.5 0 0 1 18.5 5v11.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V8.67l-8 2v7.97zm8-11v-2l-8 2v2l8-2zM7 19.64c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1zm9-2c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1z"
                        fill="#049BCF"
                        fill-rule="nonzero"
                      />
                    </svg>
                  </span>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    class="uppy-DashboardItem-previewIconBg"
                    width="58"
                    height="76"
                    viewBox="0 0 58 76"
                  >
                    <rect fill="#FFF" width="58" height="76" rx="3" fill-rule="evenodd" />
                  </svg>
                </div>
              </div>
              <div class="uppy-DashboardItem-progress">
                <button
                  class="uppy-u-reset uppy-DashboardItem-progressIndicator"
                  type="button"
                  aria-label="Pausar subida"
                  title="Pausar subida"
                >
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    width="70"
                    height="70"
                    viewBox="0 0 36 36"
                    class="UppyIcon UppyIcon-progressCircle"
                  >
                    <g class="progress-group">
                      <circle class="bg" r="15" cx="18" cy="18" stroke-width="2" fill="none" />
                      <circle
                        class="progress"
                        r="15"
                        cx="18"
                        cy="18"
                        transform="rotate(-90, 18, 18)"
                        stroke-width="2"
                        fill="none"
                        stroke-dasharray="94.24777960769379"
                        stroke-dashoffset="94.24777960769379"
                      />
                    </g>
                    <g>
                      <polygon class="play" transform="translate(3, 3)" points="12 20 12 10 20 15" />
                      <g class="pause" transform="translate(14.5, 13)">
                        <rect x="0" y="0" width="2" height="10" rx="0" />
                        <rect x="5" y="0" width="2" height="10" rx="0" />
                      </g>
                      <polygon
                        class="cancel"
                        transform="translate(2, 2)"
                        points="19.8856516 11.0625 16 14.9481516 12.1019737 11.0625 11.0625 12.1143484 14.9481516 16 11.0625 19.8980263 12.1019737 20.9375 16 17.0518484 19.8856516 20.9375 20.9375 19.8980263 17.0518484 16 20.9375 12"
                      />
                    </g>
                    <polygon
                      class="check"
                      transform="translate(2, 3)"
                      points="14 22.5 7 15.2457065 8.99985857 13.1732815 14 18.3547104 22.9729883 9 25 11.1005634"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="9" style="text-align: right;">
          <span>Recurso Público</span>
          <c-switch v-if="f.visibilidad == 'PUBLICO'" color="success" label variant="pill" checked @change="setValueVisibilidad($event,f)" />
          <c-switch v-if="f.visibilidad != 'PUBLICO'" color="success" label variant="pill" @change="setValueVisibilidad($event,f)" />
          <vue-tags-input
            v-model="tagsEdit[index]"
            :tags="f.tempTags"
            :placeholder="placeholderTags"
            @tags-changed="newTags => f.tempTags = newTags"
            style="margin-top: 10px;"
          />
          <br>
          
        </b-col>
      </b-row>
    </div>
    <div style="margin-top:20px;">
      <vue-tags-input
        v-model="tag"
        :tags="tags"
        :placeholder="placeholderTags"
        @tags-changed="newTags => tags = newTags"
      />
    </div>
    <div slot="modal-footer">
      <b-spinner
        v-if="isLoading"
        variant="primary"
        label="Spinning"
        style="vertical-align: middle; margin-right:20px;"
      ></b-spinner>
      <b-button
        v-if="!isLoading"
        variant="primary"
        class="mr-2"
        @click="saveEditarRecursos"
      >Guardar cambios</b-button>
      <b-button @click="close">Cancelar</b-button>
    </div>
  </b-modal>
</template>
<script>
import VueTagsInput from "@johmun/vue-tags-input";
import RecursoService from "@/services/recurso.service";
import { Switch as cSwitch } from '@coreui/vue'


Array.prototype.unique = function() {
  var a = this.concat();
  for (var i = 0; i < a.length; ++i) {
    for (var j = i + 1; j < a.length; ++j) {
      if (a[i] === a[j]) a.splice(j--, 1);
    }
  }

  return a;
};

export default {
  name: "modal-editar-multi-recursos",
  components: {
    VueTagsInput,
    cSwitch
  },
  props: {
    dataSelected: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      placeholderTags: "Agrega etiquetas",
      tag: "",
      tagsEdit: [],
      tags: [],
      user: this.$store.getters["auth/infoUser"],
      isLoading: false
    };
  },
  methods: {
    recursosSelected: function() {
      console.log(this.dataSelected);
    },
    saveEditarRecursos: function() {
      console.log(this.dataSelected);
      var totalFiles = this.dataSelected.length;
      var resolversTotal = 0;

      var newTags = [];
      this.tags.forEach(tag => {
        newTags.push(tag.text);
      });

      this.isLoading = true;

      this.dataSelected.forEach(el => {
        el.tags = [];
        // obtenemos la tempTags que son las que se editan por cada recurso individualmente
        var newTempTags = [];
        el.tempTags.forEach(tt => {
          newTempTags.push(tt.text);
        });

        var uniqueTags = el.tags.concat(newTempTags).unique();
        var updateTags = uniqueTags.concat(newTags).unique();
        el.tags = updateTags;

        RecursoService.edit({ query: { _id: el._id }, data: el }).then(
          result => {
            resolversTotal++;
            if (resolversTotal == totalFiles) {
              setTimeout(() => {
                this.$root.triggetSuccessMgs("Datos guardados con éxito", "");
                this.$emit("onSuccessFiles");
                this.close();
                this.isLoading = false;
              }, 1000);
            }
          }
        );
      });
    },
    close() {
      this.$bvModal.hide("modal-editar-multi-recursos");
      this.tags = [];
    },
    setValueVisibilidad(e,file){
      console.log(e);
      if(e){
        file.visibilidad = 'PUBLICO'
      } else {
        file.visibilidad = 'PRIVADO'
      }
    }
  }
};
</script>
<style lang="scss">
.recurso-obj-content {
  width: 100%;
  height: 100%;
  padding: 5px;
  border: 2px solid #eeeeee;
}
.recurso-img-content {
  object-fit: cover;
  height: 100%;
  width: 100%;
}
.switch-label{
  margin-left: 10px;
  vertical-align: middle;
}
</style>